<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="ASP计划排产数据 center_5"></chart-title>
    <el-row id="center_5">
      <el-col :lg="8" :md="8" :sm="8" :xs="8">
        <div class="circlr_item">
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">{{
              getPercentage(scheduleData.new_line_area, scheduleData.old_line_area)
            }}%</span></dv-decoration-9
          >
          <div class="circlr_item_subtext">今日新线排产：{{ scheduleData.new_line_area }}</div>
          <div class="circlr_item_subtext">今日老线排产：{{ scheduleData.old_line_area }}</div>
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xs="8"
        ><div class="circlr_item">
          <div class="circlr_item_subtext">未排产：{{ scheduleData.unscheduled_area }}</div>
          <div class="circlr_item_subtext">今日排产：{{ scheduleData.today_scheduled_area }}</div>
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">{{
              getPercentage(scheduleData.unscheduled_area, scheduleData.today_scheduled_area)
            }}%</span></dv-decoration-9
          >
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xs="8"
        ><div class="circlr_item">
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">{{
              getPercentage(scheduleData.new_line_card_area, scheduleData.old_line_card_area)
            }}%</span></dv-decoration-9
          >
          <div class="circlr_item_subtext">新线流程卡：{{ scheduleData.new_line_card_area }}</div>
          <div class="circlr_item_subtext">老线流程卡：{{ scheduleData.old_line_card_area }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { planData } from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_5",
  components: { ChartTitle },
  data() {
    return {
      scheduleData: ""
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      planData().then((resp) => {
        this.scheduleData = resp.data;
      });
    },
    getPercentage(v1, v2) {
      const nv1 = Number(v1);
      const nv2 = Number(v2);
      if (nv1 + nv2 == 0) {
        return 0;
      } else {
        return ((nv2 / (nv1 + nv2)) * 100).toFixed(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 27vh;
  #center_5 {
    height: calc(100% - 30px);
    padding: 0 10px;
    .circlr_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      .circlr {
        height: 100px;
        width: 100px;
        margin-bottom: 16px;
        .circlr_text {
          color: #dcdfe6;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .circlr_item_subtext {
        color: #ebeef5;
        margin-bottom: 6px;
      }
    }
  }
}
</style>
